import {connect} from "react-redux";
import CorporateMallForm from "./CorporateMallFirstInteractionForm";
import {bindActionCreators} from "redux";
import {
    corporateAutofillData
  } from "services/redux/installation/firForms/action";

const mapStateToProps = (state) => ({
    corporateAutofill: state.firAutofillData.corporateAutofill,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            corporateAutofillData
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(CorporateMallForm);
